import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import * as Types from '../../../../types/api.types.generated.d';

const defaultOptions = {} as const;
export type MarkApplicationsAsViewedMutationVariables = Types.Exact<{
  jobOrderIds: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
}>;

export type MarkApplicationsAsViewedMutation = {
  __typename?: 'Mutation';
  markApplicationsAsViewed: number;
};

export const MarkApplicationsAsViewedDocument = gql`
  mutation markApplicationsAsViewed($jobOrderIds: [String!]!) {
    markApplicationsAsViewed(jobOrderIds: $jobOrderIds)
  }
`;
export type MarkApplicationsAsViewedMutationFn = Apollo.MutationFunction<
  MarkApplicationsAsViewedMutation,
  MarkApplicationsAsViewedMutationVariables
>;

/**
 * __useMarkApplicationsAsViewedMutation__
 *
 * To run a mutation, you first call `useMarkApplicationsAsViewedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkApplicationsAsViewedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markApplicationsAsViewedMutation, { data, loading, error }] = useMarkApplicationsAsViewedMutation({
 *   variables: {
 *      jobOrderIds: // value for 'jobOrderIds'
 *   },
 * });
 */
export function useMarkApplicationsAsViewedMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkApplicationsAsViewedMutation,
    MarkApplicationsAsViewedMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MarkApplicationsAsViewedMutation,
    MarkApplicationsAsViewedMutationVariables
  >(MarkApplicationsAsViewedDocument, options);
}
export type MarkApplicationsAsViewedMutationHookResult = ReturnType<
  typeof useMarkApplicationsAsViewedMutation
>;
export type MarkApplicationsAsViewedMutationResult =
  Apollo.MutationResult<MarkApplicationsAsViewedMutation>;
export type MarkApplicationsAsViewedMutationOptions = Apollo.BaseMutationOptions<
  MarkApplicationsAsViewedMutation,
  MarkApplicationsAsViewedMutationVariables
>;
